import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Typography,
} from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { motion } from "framer-motion";

const Schedule = ({ schedule }) => {
  if (!schedule || schedule.length === 0) {
    return (
      <Typography color="textSecondary">No schedule available.</Typography>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <TableContainer
        component={Paper}
        elevation={4}
        sx={{
          borderRadius: "12px",
          overflow: "hidden",
          marginTop: "1rem",
        }}
      >
        <Table>
          <TableBody>
            {schedule.map((slot, index) => (
              <motion.tr
                key={index}
                whileHover={{ scale: 1.05 }}
                transition={{ type: "spring", stiffness: 200 }}
              >
                <TableRow>
                  <TableCell component="th" scope="row">
                    <AccessTimeIcon
                      sx={{
                        color: "#1976d2",
                        marginRight: "8px",
                        verticalAlign: "middle",
                      }}
                    />
                    <Typography
                      variant="body1"
                      component="span"
                      sx={{ fontWeight: "bold" }}
                    >
                      {slot.day}
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography variant="body2" color="text.secondary">
                      {slot.time}
                    </Typography>
                  </TableCell>
                </TableRow>
              </motion.tr>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </motion.div>
  );
};

export default Schedule;
